export const phoneCodes = [
    {
        country_code: '+1',
        country: 'us',
    },
    {
        country_code: '+93',
        country: 'af',
    },
    {
        country_code: '+355',
        country: 'al',
    },
    {
        country_code: '+213',
        country: 'dz',
    },
    {
        country_code: '+1684',
        country: 'as',
    },
    {
        country_code: '+376',
        country: 'ad',
    },
    {
        country_code: '+244',
        country: 'ao',
    },
    {
        country_code: '+1264',
        country: 'ai',
    },
    {
        country_code: '+672',
        country: 'aq',
    },
    {
        country_code: '+1',
        country: 'ag',
    },
    {
        country_code: '+54',
        country: 'ar',
    },
    {
        country_code: '+374',
        country: 'am',
    },
    {
        country_code: '+297',
        country: 'aw',
    },
    {
        country_code: '+61',
        country: 'au',
    },
    {
        country_code: '+43',
        country: 'at',
    },
    {
        country_code: '+994',
        country: 'az',
    },
    {
        country_code: '+1242',
        country: 'bs',
    },
    {
        country_code: '+973',
        country: 'bh',
    },
    {
        country_code: '+880',
        country: 'bd',
    },
    {
        country_code: '+1246',
        country: 'bb',
    },
    {
        country_code: '+375',
        country: 'by',
    },
    {
        country_code: '+32',
        country: 'be',
    },
    {
        country_code: '+501',
        country: 'bz',
    },
    {
        country_code: '+229',
        country: 'bj',
    },
    {
        country_code: '+1',
        country: 'bm',
    },
    {
        country_code: '+975',
        country: 'bt',
    },
    {
        country_code: '+591',
        country: 'bo',
    },
    {
        country_code: '+387',
        country: 'ba',
    },
    {
        country_code: '+267',
        country: 'bw',
    },
    {
        country_code: '+55',
        country: 'br',
    },
    {
        country_code: '+673',
        country: 'bn',
    },
    {
        country_code: '+359',
        country: 'bg',
    },
    {
        country_code: '+226',
        country: 'bf',
    },
    {
        country_code: '+257',
        country: 'bi',
    },
    {
        country_code: '+855',
        country: 'kh',
    },
    {
        country_code: '+237',
        country: 'cm',
    },
    {
        country_code: '+1',
        country: 'ca',
    },
    {
        country_code: '+238',
        country: 'cv',
    },
    {
        country_code: '+1',
        country: 'ky',
    },
    {
        country_code: '+236',
        country: 'cf',
    },
    {
        country_code: '+235',
        country: 'td',
    },
    {
        country_code: '+56',
        country: 'cl',
    },
    {
        country_code: '+86',
        country: 'cn',
    },
    {
        country_code: '+61',
        country: 'cx',
    },
    {
        country_code: '+61',
        country: 'cc',
    },
    {
        country_code: '+57',
        country: 'co',
    },
    {
        country_code: '+269',
        country: 'km',
    },
    {
        country_code: '+242',
        country: 'cg',
    },
    {
        country_code: '+682',
        country: 'ck',
    },
    {
        country_code: '+506',
        country: 'cr',
    },
    {
        country_code: '+225',
        country: 'ci',
    },
    {
        country_code: '+385',
        country: 'hr',
    },
    {
        country_code: '+53',
        country: 'cu',
    },
    {
        country_code: '+357',
        country: 'cy',
    },
    {
        country_code: '+420',
        country: 'cz',
    },
    {
        country_code: '+243',
        country: 'cd',
    },
    {
        country_code: '+45',
        country: 'dk',
    },
    {
        country_code: '+253',
        country: 'dj',
    },
    {
        country_code: '+1767',
        country: 'dm',
    },
    {
        country_code: '+1809',
        country: 'do',
    },
    {
        country_code: '+593',
        country: 'ec',
    },
    {
        country_code: '+20',
        country: 'eg',
    },
    {
        country_code: '+503',
        country: 'sv',
    },
    {
        country_code: '+240',
        country: 'gq',
    },
    {
        country_code: '+291',
        country: 'er',
    },
    {
        country_code: '+372',
        country: 'ee',
    },
    {
        country_code: '+251',
        country: 'et',
    },
    {
        country_code: '+500',
        country: 'fk',
    },
    {
        country_code: '+298',
        country: 'fo',
    },
    {
        country_code: '+691',
        country: 'fm',
    },
    {
        country_code: '+679',
        country: 'fj',
    },
    {
        country_code: '+358',
        country: 'fi',
    },
    {
        country_code: '+33',
        country: 'fr',
    },
    {
        country_code: '+594',
        country: 'gf',
    },
    {
        country_code: '+689',
        country: 'pf',
    },
    {
        country_code: '+241',
        country: 'ga',
    },
    {
        country_code: '+220',
        country: 'gm',
    },
    {
        country_code: '+995',
        country: 'ge',
    },
    {
        country_code: '+49',
        country: 'de',
    },
    {
        country_code: '+233',
        country: 'gh',
    },
    {
        country_code: '+350',
        country: 'gi',
    },
    {
        country_code: '+30',
        country: 'gr',
    },
    {
        country_code: '+299',
        country: 'gl',
    },
    {
        country_code: '+1473',
        country: 'gd',
    },
    {
        country_code: '+590',
        country: 'gp',
    },
    {
        country_code: '+1671',
        country: 'gu',
    },
    {
        country_code: '+502',
        country: 'gt',
    },
    {
        country_code: '+44',
        country: 'gg',
    },
    {
        country_code: '+224',
        country: 'gn',
    },
    {
        country_code: '+245',
        country: 'gw',
    },
    {
        country_code: '+592',
        country: 'gy',
    },
    {
        country_code: '+509',
        country: 'ht',
    },
    {
        country_code: '+504',
        country: 'hn',
    },
    {
        country_code: '+852',
        country: 'hk',
    },
    {
        country_code: '+36',
        country: 'hu',
    },
    {
        country_code: '+354',
        country: 'is',
    },
    {
        country_code: '+91',
        country: 'in',
    },
    {
        country_code: '+62',
        country: 'id',
    },
    {
        country_code: '+98',
        country: 'ir',
    },
    {
        country_code: '+964',
        country: 'iq',
    },
    {
        country_code: '+353',
        country: 'ie',
    },
    {
        country_code: '+44',
        country: 'im',
    },
    {
        country_code: '+972',
        country: 'il',
    },
    {
        country_code: '+39',
        country: 'it',
    },
    {
        country_code: '+1',
        country: 'jm',
    },
    {
        country_code: '+81',
        country: 'jp',
    },
    {
        country_code: '+44',
        country: 'je',
    },
    {
        country_code: '+962',
        country: 'jo',
    },
    {
        country_code: '+7',
        country: 'kz',
    },
    {
        country_code: '+254',
        country: 'ke',
    },
    {
        country_code: '+686',
        country: 'ki',
    },
    {
        country_code: '+82',
        country: 'kr',
    },
    {
        country_code: '+850',
        country: 'kp',
    },
    {
        country_code: '+965',
        country: 'kw',
    },
    {
        country_code: '+996',
        country: 'kg',
    },
    {
        country_code: '+856',
        country: 'la',
    },
    {
        country_code: '+371',
        country: 'lv',
    },
    {
        country_code: '+961',
        country: 'lb',
    },
    {
        country_code: '+266',
        country: 'ls',
    },
    {
        country_code: '+231',
        country: 'lr',
    },
    {
        country_code: '+218',
        country: 'ly',
    },
    {
        country_code: '+423',
        country: 'li',
    },
    {
        country_code: '+370',
        country: 'lt',
    },
    {
        country_code: '+352',
        country: 'lu',
    },
    {
        country_code: '+853',
        country: 'mo',
    },
    {
        country_code: '+389',
        country: 'mk',
    },
    {
        country_code: '+261',
        country: 'mg',
    },
    {
        country_code: '+265',
        country: 'mw',
    },
    {
        country_code: '+60',
        country: 'my',
    },
    {
        country_code: '+960',
        country: 'mv',
    },
    {
        country_code: '+223',
        country: 'ml',
    },
    {
        country_code: '+356',
        country: 'mt',
    },
    {
        country_code: '+692',
        country: 'mh',
    },
    {
        country_code: '+596',
        country: 'mq',
    },
    {
        country_code: '+222',
        country: 'mr',
    },
    {
        country_code: '+230',
        country: 'mu',
    },
    {
        country_code: '+269',
        country: 'yt',
    },
    {
        country_code: '+52',
        country: 'mx',
    },
    {
        country_code: '+373',
        country: 'md',
    },
    {
        country_code: '+377',
        country: 'mc',
    },
    {
        country_code: '+976',
        country: 'mn',
    },
    {
        country_code: '+382',
        country: 'me',
    },
    {
        country_code: '+1664',
        country: 'ms',
    },
    {
        country_code: '+212',
        country: 'ma',
    },
    {
        country_code: '+258',
        country: 'mz',
    },
    {
        country_code: '+95',
        country: 'mm',
    },
    {
        country_code: '+264',
        country: 'na',
    },
    {
        country_code: '+674',
        country: 'nr',
    },
    {
        country_code: '+977',
        country: 'np',
    },
    {
        country_code: '+31',
        country: 'nl',
    },
    {
        country_code: '+599',
        country: 'an',
    },
    {
        country_code: '+687',
        country: 'nc',
    },
    {
        country_code: '+64',
        country: 'nz',
    },
    {
        country_code: '+505',
        country: 'ni',
    },
    {
        country_code: '+227',
        country: 'ne',
    },
    {
        country_code: '+234',
        country: 'ng',
    },
    {
        country_code: '+683',
        country: 'nu',
    },
    {
        country_code: '+672',
        country: 'nf',
    },
    {
        country_code: '+1670',
        country: 'mp',
    },
    {
        country_code: '+47',
        country: 'no',
    },
    {
        country_code: '+92',
        country: 'pk',
    },
    {
        country_code: '+680',
        country: 'pw',
    },
    {
        country_code: '+970',
        country: 'ps',
    },
    {
        country_code: '+507',
        country: 'pa',
    },
    {
        country_code: '+675',
        country: 'pg',
    },
    {
        country_code: '+595',
        country: 'py',
    },
    {
        country_code: '+51',
        country: 'pe',
    },
    {
        country_code: '+63',
        country: 'ph',
    },
    {
        country_code: '+870',
        country: 'pn',
    },
    {
        country_code: '+48',
        country: 'pl',
    },
    {
        country_code: '+351',
        country: 'pt',
    },
    {
        country_code: '+1',
        country: 'pr',
    },
    {
        country_code: '+974',
        country: 'qa',
    },
    {
        country_code: '+262',
        country: 're',
    },
    {
        country_code: '+40',
        country: 'ro',
    },
    {
        country_code: '+7',
        country: 'ru',
    },
    {
        country_code: '+250',
        country: 'rw',
    },
    {
        country_code: '+290',
        country: 'sh',
    },
    {
        country_code: '+1869',
        country: 'kn',
    },
    {
        country_code: '+1',
        country: 'lc',
    },
    {
        country_code: '+508',
        country: 'pm',
    },
    {
        country_code: '+1',
        country: 'vc',
    },
    {
        country_code: '+685',
        country: 'ws',
    },
    {
        country_code: '+378',
        country: 'sm',
    },
    {
        country_code: '+239',
        country: 'st',
    },
    {
        country_code: '+966',
        country: 'sa',
    },
    {
        country_code: '+221',
        country: 'sn',
    },
    {
        country_code: '+381',
        country: 'rs',
    },
    {
        country_code: '+248',
        country: 'sc',
    },
    {
        country_code: '+232',
        country: 'sl',
    },
    {
        country_code: '+65',
        country: 'sg',
    },
    {
        country_code: '+421',
        country: 'sk',
    },
    {
        country_code: '+386',
        country: 'si',
    },
    {
        country_code: '+677',
        country: 'sb',
    },
    {
        country_code: '+252',
        country: 'so',
    },
    {
        country_code: '+27',
        country: 'za',
    },
    {
        country_code: '+34',
        country: 'es',
    },
    {
        country_code: '+94',
        country: 'lk',
    },
    {
        country_code: '+249',
        country: 'sd',
    },
    {
        country_code: '+968',
        country: 'om',
    },
    {
        country_code: '+597',
        country: 'sr',
    },
    {
        country_code: '+268',
        country: 'sz',
    },
    {
        country_code: '+46',
        country: 'se',
    },
    {
        country_code: '+41',
        country: 'ch',
    },
    {
        country_code: '+963',
        country: 'sy',
    },
    {
        country_code: '+886',
        country: 'tw',
    },
    {
        country_code: '+992',
        country: 'tj',
    },
    {
        country_code: '+255',
        country: 'tz',
    },
    {
        country_code: '+66',
        country: 'th',
    },
    {
        country_code: '+670',
        country: 'tl',
    },
    {
        country_code: '+228',
        country: 'tg',
    },
    {
        country_code: '+690',
        country: 'tk',
    },
    {
        country_code: '+676',
        country: 'to',
    },
    {
        country_code: '+1868',
        country: 'tt',
    },
    {
        country_code: '+216',
        country: 'tn',
    },
    {
        country_code: '+90',
        country: 'tr',
    },
    {
        country_code: '+993',
        country: 'tm',
    },
    {
        country_code: '+1649',
        country: 'tc',
    },
    {
        country_code: '+688',
        country: 'tv',
    },
    {
        country_code: '+256',
        country: 'ug',
    },
    {
        country_code: '+380',
        country: 'ua',
    },
    {
        country_code: '+971',
        country: 'ae',
    },
    {
        country_code: '+44',
        country: 'gb',
    },
    {
        country_code: '+598',
        country: 'uy',
    },
    {
        country_code: '+998',
        country: 'uz',
    },
    {
        country_code: '+678',
        country: 'vu',
    },
    {
        country_code: '+39',
        country: 'va',
    },
    {
        country_code: '+58',
        country: 've',
    },
    {
        country_code: '+84',
        country: 'vn',
    },
    {
        country_code: '+1284',
        country: 'vg',
    },
    {
        country_code: '+1340',
        country: 'vi',
    },
    {
        country_code: '+681',
        country: 'wf',
    },
    {
        country_code: '+967',
        country: 'ye',
    },
    {
        country_code: '+260',
        country: 'zm',
    },
    {
        country_code: '+263',
        country: 'zw',
    }
];
